/// <amd-module name="Release/Helpers/Telemetry" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";
import { traceException } from "VSS/Platform/Trace";

export const FeatureArea = "DefinitionsHub";

const successEvent: string = "Success";
const failureEvent: string = "Failure";
const clickEvent: string = "Click";

const sourceKey = "source";

export function publishSuccessEvent(pageContext: IVssPageContext, feature: string, source: string = "", data: { [key: string]: string } = {}): void {
    publishTelemetryEvent(pageContext, feature, successEvent, source, data);
}

export function publishFailedEvent(pageContext: IVssPageContext, feature: string, source: string = "", data: { [key: string]: string } = {}): void {
    publishTelemetryEvent(pageContext, feature, failureEvent, source, data);
}

export function publishClickEvent(pageContext: IVssPageContext, feature: string, source: string = "", data: { [key: string]: string } = {}): void {
    publishTelemetryEvent(pageContext, feature, clickEvent, source, data);
}

function publishTelemetryEvent(pageContext: IVssPageContext, feature: string, eventType: string, source: string = "", data: { [key: string]: string }): void {
    if (source) {
        data[sourceKey] = source;
    }

    pageContext.getService<IVssTelemetryService>("IVssTelemetryService").publishEvent(
        FeatureArea,
        feature,
        { [eventType]: 1, ...data },
        "0000000d-0000-8888-8000-000000000000"
    );
}

export function traceHubException(pageContext: IVssPageContext, feature: string, exception: Error | string, properties?: { [key: string]: any }): void {
    traceException(pageContext, FeatureArea, feature, exception, properties);
}

